export enum DxLogoutStrategyType {
  SYNC = 'SYNC',
  ASYNC = 'ASYNC'
}
